// import React from "react";
import "./button.css";
import ButtonPropTypes from "./ButtonPropTypes";

const Button = ({
  label,
  onClick,
  type = "button",
  variant = "primary",
  disabled = false,
  style = {},
  className = "",
  children,
  actionType = "default",
  redirectUrl = "",
  calculate = () => {},
  ...rest
}) => {
  const handleClick = (e) => {
    if (disabled) return;

    switch (actionType) {
      case "calculate":
        calculate();
        break;
      case "redirect":
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          console.error("URL not provided, provide URL");
        }
        break;
      default:
        onClick && onClick(e);
    }
  };

  return (
    <button
      type={type}
      className={`btn btn-${variant} ${className}`}
      style={style}
      onClick={handleClick}
      disabled={disabled}
      {...rest}
    >
      {children || label}
    </button>
  );
};

// Define PropTypes for the component
Button.propTypes = ButtonPropTypes;

export default Button;
